import {Injectable} from '@angular/core';
import {Permission} from '../pages/settings/permission/permission.model';

export interface UserInStorage {
    userId: number;
    mobile: string;
    displayName: string;
    token: string;
    refreshToken: string;
    roles: any[];
    regions: any[];
    webAllowed:  boolean;
}

export interface LoginInfoInStorage {
    success: boolean;
    message: string;
    landingPage: string;
    user?: UserInStorage;

}

@Injectable()
export class UserInfoService {
    public userPermission: any = Permission;
    permission = [];
    public currentUserKey = 'currentUser';
    /*public userPermission = 'read';*/
    public storage: Storage = sessionStorage; // <--- you may switch between sessionStorage or LocalStrage (only one place to change)

    constructor() {
    }

    // roles
    setRole(id: string) {
        this.storage.setItem('roles', id);
    }

    setRegion(id: string) {
        this.storage.setItem('regions', id);
    }

  /*  isSuperAdmin() {
        try {
            const roles: string = this.storage.getItem('roles');
                const allRole = roles.split(',');
            if (allRole.includes('1')) {
                return true;
            }
            return false;
        } catch (e) {
            return null;
        }
    }*/
    isSuperAdmin() {
        try {
            const roles: string = this.storage.getItem('roles');
            const allRole = roles.split(',');
            if (allRole.includes('1')) {
                return true;
            }
            return false;
        } catch (e) {
            return null;
        }
    }
    isAdmin() {
        try {
            const regions: string = this.storage.getItem('regions');
            const allRegion = regions.split(',');
            if ((allRegion.includes('1')) || (allRegion.includes('5')) || (allRegion.includes('11')) || (allRegion.includes('12')) || (allRegion.includes('13')) || (allRegion.includes('14'))) {
                return true;
            }
            return false;
        } catch (e) {
            return null;
        }
    }
    getRole() {
        try {
            const roles: string = this.storage.getItem('roles');
            const allRole = roles.split(',');
            return allRole[0];
        } catch (e) {
            return null;
        }
    }
    getRegion() {
        try {
            const regions: any = this.storage.getItem('regions');
            const allRegion = regions.split(',');
            return allRegion[0];
        } catch (e) {
            return null;
        }
    }

    // permission
    setPermission(userPermit: string) {
        this.storage.setItem('permissions', userPermit);
    }

    getPermission() {
        try {
            const per: string = this.storage.getItem('permissions');
            const allPerm = per.split(',');
            return allPerm;
        } catch (e) {
            return null;
        }
    }

    // Store userinfo from session storage
    storeUserInfo(userInfoString: string) {
        this.storage.setItem(this.currentUserKey, userInfoString);
    }


    // Remove userinfo from session storage
    removeUserInfo() {
        this.storage.removeItem('this.currentUserKey');

    }

    // Remove userinfo from session storage
    removeRoles() {
        this.storage.removeItem('roles');

    }

    // Get userinfo from session storage
    getUserInfo(): UserInStorage | null {
        try {
            const userInfoString: string = this.storage.getItem(this.currentUserKey);
            if (userInfoString) {
                const userObj: UserInStorage = JSON.parse(this.storage.getItem(this.currentUserKey));
                return userObj;
            } else {
                return null;
            }
        } catch (e) {
            return null;
        }
    }

    isLoggedIn(): boolean {
        return this.storage.getItem(this.currentUserKey) ? true : false;
    }

    // Get User's Display name from session storage
    getUserName(): string {
        const userObj: UserInStorage = this.getUserInfo();
        if (userObj !== null) {
            return userObj.displayName
        }
        return 'no-user';
    }

    // Get User's Id from session storage
    getUserId(): number {
        const userObj: UserInStorage = this.getUserInfo();
        if (userObj !== null) {
            return userObj.userId;
        }
        return 0;
    }

    getStoredToken(): string | null {
        const userObj: UserInStorage = this.getUserInfo();
        if (userObj !== null) {
            return userObj.token;
        }
        return null;
    }

    getRefreshToken(): string | null {
        const userObj: UserInStorage = this.getUserInfo();
        if (userObj !== null) {
            return userObj.refreshToken;
        }
        return null;
    }
}
